import styled from "styled-components";
import { palette } from "@interia/common/styles/global";
import { up, down } from 'styled-breakpoints';
import { P, parsedHtml } from "@interia/common/components/typography";
import { GatsbyImage } from "gatsby-plugin-image";

export const Row = styled.div`
  display: flex;
`


export const ImageColumn = styled.div`
  ${down('md')}{
    display: none;
  }
  flex: 1;
`

export const BorderColumn = styled.div`
  flex: 1;
  position: relative;
`

export const DescriptionColumn = styled.div`
  flex: 9;
`
export const Description = styled(parsedHtml)`
  padding-bottom: 3rem;
  margin: 0;
  > p {
    margin: 0;
  }
  ${down('sm')}{
    margin-left: 2rem;
  }
`

export const Image = styled(GatsbyImage)`

`
export const MiddleLine = styled.div`
color: ${palette.grey};
height: 100%;
width: 5px;
background-image: linear-gradient(${palette.grey} 40%, #ffffff 0%);
background-size: 10px 50px;
align-self: center;
position: absolute;
left: calc(50% - 2.5px);
`

export const BlueCircle = styled.figure`
  margin: 0;
  position: absolute;
  top:0;
  left: calc(50% - 1.5rem);
  z-index: 2;
  background-color: #00DFB8;
  width: 3rem;
  height: 3rem;
  border-radius: 50%;
`

export const Arrow = styled.figure`
  position: absolute;
  bottom:-5px;
  left: calc(50% - 1rem);
  z-index: 3;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 2rem 1rem 0 1rem;
  border-color: ${palette.grey} transparent transparent transparent;
  margin: 0;
`